export const inspectTable = [
  {
    title: "소음노출평가",
    content: "전 작업 공정 소음 수준에 대한 평가를 하는가?",
    isChecked: "",
  },
  {
    title: "소음노출평가",
    content: "노출 기준 초과 소음에 대하여 공학적 또는 관리적 대책을 수립 시행하고 있는가?",
    isChecked: "",
  },
  {
    title: "소음노출평가",
    content: "개선대책 수립 시 근로자 및 관리감독자의 의견이 반영되는가?",
    isChecked: "",
  },
  {
    title: "소음노출평가",
    content: "소음수준은 중요한 공정의 변화가 있을 때에도 평가되는가?",
    isChecked: "",
  },
  {
    title: "소음노출평가",
    content: "120dB(A)를 초과하는 충격소음에 노출되는가?",
    isChecked: "",
  },
  {
    title: "소음노출평가",
    content: "누적소음기나 일반 소음기의 측정 전후에 보정은 실시하는가?\n" +
      "  <작업환경측정시 측정기관에서 실시>",
    isChecked: "",
  },
  {
    title: "소음노출평가",
    content: "소음평가 결과는 기록되고 보관되는가?",
    isChecked: "",
  },
  {
    title: "소음노출평가",
    content: "근로자들은 소음평가 결과를 통보 받는가?",
    isChecked: "",
  },
  {
    title: "소음노출평가",
    content: "소음 측정 결과는 해당 공정 관리감독자에게 통보되는가?",
    isChecked: "",
  },
  {
    title: "청력평가",
    content: "청력검사 대상 작업자들이 매년 청력검사를 받는가?",
    isChecked: "",
  },
  {
    title: "청력평가",
    content: "소음 발생 작업장이나 노출 기준 초과 공정에 배치되는 근로자들에 대하여 배치전 청력검진과 교육이 이루어지는가?",
    isChecked: "",
  },
  {
    title: "청력평가",
    content: "청력검사를 하는 사람은 훈련되거나 자격이 있는 사람인가?\n<특수건강진단 기관>",
    isChecked: "",
  },
  {
    title: "청력평가",
    content: "소음에 대한 특수검진 결과 C1판정자의 경우 그 결과를 해당 근로자에게 통보하여 청력손실 진행을 막기 위한 예방적 조치를 취하는가?",
    isChecked: "",
  },
  {
    title: "청력평가",
    content: "청력검사 결과는 근로자에게 알리고 있는가?",
    isChecked: "",
  },
  {
    title: "청력평가",
    content: "청력검사 결과는 기록되고 보관되는가?",
    isChecked: "",
  },
  {
    title: "청력평가",
    content: "청력검사실은 순음 청력 검사지침(KOSHA CODE)의 기준에 적합한가?\n<특수건강진단 기관>",
    isChecked: "",
  },
  {
    title: "소음 및 청력관리 교육",
    content: "소음에 노출되는 근로자들에 대한 교육을 실시하는가?",
    isChecked: "",
  },
  {
    title: "소음 및 청력관리 교육",
    content: "교육내용에는 다음에 관한 사항이 포함되어 있는가?\n- 소음이 청력에 미치는 영향 / 청력 보호구 착용의 목적 및 방법 / 청력검사의 목적 등",
    isChecked: "",
  },
  {
    title: "소음 및 청력관리 교육",
    content: "교육을 실시하는 강사는 소음에 관한 지식이 충분한가?",
    isChecked: "",
  },
  {
    title: "청력보호구",
    content: "근로자에게 개인별 청력보호구가 지급되는가?",
    isChecked: "",
  },
  {
    title: "청력보호구",
    content: "프로그램 시행대상 공정외의 근로자가 요청하면 보호구가 지급되는가?",
    isChecked: "",
  },
  {
    title: "청력보호구",
    content: "청력보호구를 제대로 착용하는지 여부가 관리감독자에 의해 감독되는가?",
    isChecked: "",
  },
  {
    title: "청력보호구",
    content: "소음발생 공정에는 청력보호구 착용 표지가 부착되어 있는가?",
    isChecked: "",
  },

];
